import { createFileRoute } from '@tanstack/react-router'
import EanSeriesContainer from 'Admin/containers/EanSeriesContainer'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/eanseries')({
    component: () => (
        <Guard claims={['opus_user']}>
            <EanSeriesContainer />
        </Guard>
    ),
})
